import React from "react";

const SomethingElse = () => {
  return (
    <div className="Job-listing">
      <p>
        Interested in working at Dark, but didn't find a job description that
        matched? We might not be hiring your role yet, but we'd love to get to
        know you now so we can reach out when we are!
      </p>
      <p>
        As a small team, we love hearing from people who work in multiple
        spaces. Engineer, but also enjoy techncial writing? Working in support,
        but went to a bootcamp and want more code in your day-to-day? Let us
        know!
      </p>
      <p>Here are some of the roles and skillsets we are interested in:</p>
      <ul>
        <li>Engineering</li>
        <li>Design</li>
        <li>Developer Experience</li>
        <li>Community</li>
        <li>Technical Writing</li>
        <li>Content</li>
        <li>Customer Success</li>
        <li>Product Marketing</li>
        <li>Product Management</li>
        <li>Sales</li>
      </ul>

      <p>
        Send us a note to careers@darklang.com with why you're interested in
        working at Dark, and something about your prior work (LinkedIn, Resume,
        Portfolio).
      </p>
      <p>
        We'll reply, and if we're able to, we'll set up a time to chat and show
        you what we're up to.
      </p>
    </div>
  );
};

export default SomethingElse;
